var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButtonIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3125 10.3125V7.96875C10.3125 7.34715 10.5594 6.75101 10.999 6.31147C11.4385 5.87193 12.0346 5.625 12.6562 5.625H24.8438C25.4654 5.625 26.0615 5.87193 26.501 6.31147C26.9406 6.75101 27.1875 7.34715 27.1875 7.96875V22.0312C27.1875 22.6529 26.9406 23.249 26.501 23.6885C26.0615 24.1281 25.4654 24.375 24.8438 24.375H12.6562C12.0346 24.375 11.4385 24.1281 10.999 23.6885C10.5594 23.249 10.3125 22.6529 10.3125 22.0312V19.6875",
    stroke: "#6157FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9375 19.6875L21.625 15L16.9375 10.3125",
    stroke: "#6157FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.8125 15H20.6875",
    stroke: "#6157FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonIn);
export default __webpack_public_path__ + "static/media/button_in.38cd1e3eea795ca2de3c0145fafccb4b.svg";
export { ForwardRef as ReactComponent };